document.addEventListener('DOMContentLoaded', initHeaderSearchToggle);

function initHeaderSearchToggle() {
	const headerMenu = document.getElementById('Details-menu-drawer-container');
	const headerSearch = document.querySelector('.header__search');

	if (headerSearch) {
		const headerSearchToggle = headerSearch.querySelector('.search-modal--mobile--toggle');
		headerSearchToggle.addEventListener('click', toggleHeaderSearch);
	}

	function toggleHeaderSearch() {
		headerSearch.toggleAttribute('open');

		if (headerMenu.hasAttribute('open')) {
			const headerMenuToggle = headerMenu.querySelector('summary');
			headerMenuToggle.click();
		}
	}
}
